import { styled } from '@mui/material';

import { Button } from '~/components/ui/button';
import { Title } from '~/components/ui/title';
import { DESKTOP_MIN_WIDTH, TABLET_MIN_WIDTH } from '~/constants/common';

export const StyledContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBlock: '80px',
    borderRadius: '20px',
    background: 'linear-gradient(to right, rgba(4, 135, 230, 1), rgba(70, 164, 232, 1))',
    width: '100%',
    position: 'relative',
    padding: '43px 0 43px 40px',
    [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
      height: 'unset',
      padding: '40px 20px',
      flexDirection: 'column-reverse',
      gap: 32,
    },
  };
});

export const StyledImage = styled('img')(({ theme }) => {
  return {
    maxWidth: '618px',
    width: '54%',
    position: 'relative',
    right: ' -35px',
    margin: '-89px 0 -76px',
    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      position: 'static',
      width: '50%',
      margin: 0,
    },
    [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
      width: '100%',
    },
  };
});

export const StyledBackgroundImage = styled('img')(() => {
  return {
    position: 'absolute',
    transform: 'scale(1.3)',
    objectFit: 'cover',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    opacity: '0.15',
  };
});

export const StyledContent = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    maxWidth: '516px',
    [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
      width: '100%',
    },
  };
});

export const StyledTitle = styled(Title)(({ theme }) => {
  return {
    color: 'white',
    [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
      textAlign: 'center',
      fontSize: '22px',
      fontWeight: 600,
    },
  };
});

export const StyledButton = styled(Button)(({ theme }) => {
  return {
    width: 'fit-content',
    [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
      width: '100%',
    },
  };
});
